import { render } from "./LoadingWidget.vue?vue&type=template&id=b10d687e&scoped=true"
const script = {}

import "./LoadingWidget.vue?vue&type=style&index=0&id=b10d687e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10d687e"]])

export default __exports__